import {
	ACCESS_MODE,
	Advertisement,
	AdvertisementAsset,
	Campaign,
	CampaignAdvertisement,
	Client,
	LocationGroupCampaignSearch,
	MainLocationAllocation,
	SlotResults,
	User,
} from '@horasys/bellplus/common/types';
import { getPrimaryAsset } from 'services/advertising.service';
import { MatBreakPoint, MatDirection, MatJustify } from 'store/actions/common';

import {
	ADD_CAMPAIGN_ADVERTISEMENT,
	CampaignAction,
	CAMPAIGN_MANUAL_ADD_LOCATION,
	CAMPAIGN_MANUAL_ADD_LOCATION_GROUP,
	CAMPAIGN_MANUAL_DELETE_LOCATION,
	CAMPAIGN_MANUAL_DELETE_LOCATION_GROUP,
	CAMPAIGN_MANUAL_LOCATION_BOOK_SLOT,
	DELETE_CAMPAIGN_ADVERTISEMENT,
	GET_AREAS_BY_CITIES,
	GET_CAMPAIGN_ADVERTISEMENTS,
	GET_CAMPAIGN_BY_ID,
	GET_CAMPAIGN_DATA_LIST,
	GET_CITIES,
	GET_LOCATION_GROUP_MANUAL_RESULT,
	GET_LOCATION_GROUP_SEARCH_BY_CITY,
	GET_MAIN_LOCATIONS_SEARCH_BY_AREA,
	GET_MAIN_LOCATION_AUTO_RESULT,
	GET_MAIN_LOCATION_MANUAL_RESULT,
	RESET_CAMPAIGN_ADVERTISEMENT_FORM,
	RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE,
	RESET_CAMPAIGN_STATE,
	UPDATE_AUTO_RESULT_UI_STATE,
	UPDATE_CAMPAIGN_ADVERTISEMENT_FORM,
	UPDATE_CAMPAIGN_AD_UI_STATE,
	UPDATE_CAMPAIGN_FORM,
	UPDATE_CAMPAIGN_MODE,
	UPDATE_LOCATION_GROUP_MANUAL_NO_TIMES,
	UPDATE_LOCATION_GROUP_MANUAL_SELECTED_DEVICES,
	UPDATE_LOCATION_GROUP_SELECT_ALL_DEVICES,
	UPDATE_LOCATION_MANUAL_NO_TIMES,
	UPDATE_LOCATION_MANUAL_SELECTED_DEVICES,
	UPDATE_LOCATION_SELECT_ALL_DEVICES,
} from 'store/types/campaign';

export interface CampaignAdvertisementUIState {
	showConfirm: boolean;
	toolbarMode: MatDirection;
	toolbarColSize: MatBreakPoint;
	mainContainerAlign: MatJustify;
	isNewlyAllocatedSlots: boolean;
	tabValue: number;
	isChooseDevicesPopupOpen: boolean;
	isChooseDevicesViewMode: boolean;
}

const initialCampaignAdvertisementUIState: CampaignAdvertisementUIState = {
	showConfirm: false,
	toolbarMode: 'column',
	toolbarColSize: 4,
	mainContainerAlign: 'flex-start',
	isNewlyAllocatedSlots: false,
	tabValue: 0,
	isChooseDevicesPopupOpen: false,
	isChooseDevicesViewMode: false,
};
export interface CampaignStore {
	list: Array<any>;
	error: any;
	loading: boolean;
	mode: ACCESS_MODE;
	selectedId: number;
	campaign: Campaign;
	totalElements: number;
	cities: any;
	areas: any;
	mainLocationSearchResults: Array<MainLocationAllocation>;
	locationGroupSearchResults: Array<any>;
	currentSlotResults: SlotResults;
	campaignAdvertisementForm: CampaignAdvertisement;
	campaignAdvertisementState: CampaignAdvertisementUIState;
	campaignAdvertisements: Array<Advertisement>;
}
const addDays = (date: Date, days: number): Date => {
	date.setDate(date.getDate() + days);
	return date;
};
const clientObj: Client = {} as Client;
clientObj.name = '';
clientObj.companyName = '';
const userObj: Partial<User> = {} as Partial<User>;
userObj.id = 0;
userObj.username = '';

const emptyAdvertisement: Advertisement = {} as Advertisement;
const emptyCampaignAdvertisement: CampaignAdvertisement = {
	id: 0,
	advertisement: emptyAdvertisement,
	userBudget: 0,
	calculatedBudget: 0,
	isAuto: false,
	noOfTimes: 1,
	startDate: addDays(new Date(), 0),
	endDate: addDays(new Date(), 0),
	uuid: '',
	searchLocations: [],
	selectedLocationGroups: [],
	searchLocationGroups: [],
	selectedAreas: [],
	typeOfSearch: 'location',
	selectedCities: [],
	selectedLocations: [],
	index: -1,
};
const emptyCampaignObject: Campaign = {
	id: 0,
	name: '',
	originalName: '',
	salesPersonUser: userObj,
	client: clientObj,
	price: 0,
	payments: [],
	campaignAdvertisements: [],
	status: '',
	paymentReceived: 0,
	uuids: [],
	campaignPaymentDetailsResponse: [],
	campaignAdvertisementDetailsResponse: [],
};
const emptySlotResults: SlotResults = {} as SlotResults;
emptySlotResults.budget = 0;
emptySlotResults.locations = [];
emptySlotResults.uuid = '';
const initialState: CampaignStore = {
	list: [],
	error: null,
	loading: false,
	mode: 'CREATE',
	selectedId: 0,
	totalElements: 0,
	campaign: emptyCampaignObject,
	cities: [],
	areas: [],
	mainLocationSearchResults: [],
	locationGroupSearchResults: [],
	currentSlotResults: emptySlotResults,
	campaignAdvertisementForm: emptyCampaignAdvertisement,
	campaignAdvertisementState: initialCampaignAdvertisementUIState,
	campaignAdvertisements: [],
};
export const campaignReducer = (
	state = initialState,
	action: CampaignAction,
): CampaignStore => {
	switch (action.type) {
		case UPDATE_CAMPAIGN_MODE: {
			if (action.payload.mode !== 'CREATE') {
				return {
					...state,
					mode: action.payload.mode,
					selectedId: action.payload.selectedId,
				};
			} else {
				return {
					...state,
					campaign: emptyCampaignObject,
					campaignAdvertisementForm: emptyCampaignAdvertisement,
					campaignAdvertisementState: initialCampaignAdvertisementUIState,
					cities: [],
					areas: [],
					currentSlotResults: emptySlotResults,
				};
			}
		}

		case GET_CAMPAIGN_DATA_LIST: {
			return {
				...state,
				list: action.payload.list,
				totalElements: action.payload.totalElements,
			};
		}

		case GET_CITIES: {
			return {
				...state,
				cities: action.payload,
			};
		}

		case GET_AREAS_BY_CITIES: {
			return {
				...state,
				areas: action.payload,
			};
		}

		case DELETE_CAMPAIGN_ADVERTISEMENT: {
			const updatedCampaign = { ...state.campaign };
			const updateCampaignAdvertisements = updatedCampaign.campaignAdvertisements.filter(
				(campAdvertisement: CampaignAdvertisement) => {
					if (campAdvertisement.index !== action.payload) {
						return campAdvertisement;
					} else {
						return false;
					}
				},
			);
			updatedCampaign.campaignAdvertisements = [...updateCampaignAdvertisements];
			let price = 0;
			updatedCampaign.campaignAdvertisements.forEach(
				(campaignAdvertisement: CampaignAdvertisement) => {
					price = price + campaignAdvertisement.calculatedBudget;
				},
			);
			updatedCampaign.price = price;
			return {
				...state,
				campaign: { ...updatedCampaign },
			};
		}

		case GET_CAMPAIGN_ADVERTISEMENTS: {
			return {
				...state,
				campaignAdvertisements: action.payload,
			};
		}

		case ADD_CAMPAIGN_ADVERTISEMENT: {
			if (state.campaignAdvertisementForm.index === -1) {
				const updatedCampaignAdvertisement: CampaignAdvertisement = {
					...state.campaignAdvertisementForm,
				};
				updatedCampaignAdvertisement.index =
					state.campaign.campaignAdvertisements.length;
				const advertisementAsset: AdvertisementAsset = getPrimaryAsset(
					updatedCampaignAdvertisement.advertisement,
				);
				if (advertisementAsset.type === 'video') {
					updatedCampaignAdvertisement.previewUrl = advertisementAsset.url;
					updatedCampaignAdvertisement.thumbnailUrl =
						advertisementAsset.thumbnailAsset?.url;
				} else if (advertisementAsset.type === 'image') {
					updatedCampaignAdvertisement.previewUrl = advertisementAsset.url;
					updatedCampaignAdvertisement.thumbnailUrl = advertisementAsset.url;
				} else if (advertisementAsset.type === 'multipleImages') {
					updatedCampaignAdvertisement.previewUrl =
						advertisementAsset.children &&
						advertisementAsset.children?.length > 0
							? advertisementAsset.children[0].url
							: '';
					updatedCampaignAdvertisement.thumbnailUrl =
						advertisementAsset.children &&
						advertisementAsset.children?.length > 0
							? advertisementAsset.children[0].url
							: '';
				}

				let price = 0;
				state.campaign.campaignAdvertisements.forEach(
					(campaignAdvertisement: CampaignAdvertisement) => {
						price = price + campaignAdvertisement.calculatedBudget;
					},
				);
				price = price + updatedCampaignAdvertisement.calculatedBudget;
				const updatedCampaign = { ...state.campaign };
				updatedCampaign.campaignAdvertisements = [
					...updatedCampaign.campaignAdvertisements,
					updatedCampaignAdvertisement,
				];
				updatedCampaign.price = price;
				return {
					...state,
					campaign: updatedCampaign,
				};
			} else {
				const updatedCampaignAdvertisement: CampaignAdvertisement = {
					...state.campaignAdvertisementForm,
				};
				const advertisementAsset: AdvertisementAsset = getPrimaryAsset(
					updatedCampaignAdvertisement,
				);
				if (advertisementAsset.type === 'video') {
					updatedCampaignAdvertisement.previewUrl = advertisementAsset.url;
					updatedCampaignAdvertisement.thumbnailUrl =
						advertisementAsset.thumbnailAsset?.url;
				} else if (advertisementAsset.type === 'image') {
					updatedCampaignAdvertisement.previewUrl = advertisementAsset.url;
					updatedCampaignAdvertisement.thumbnailUrl = advertisementAsset.url;
				} else if (advertisementAsset.type === 'multipleImages') {
					updatedCampaignAdvertisement.previewUrl =
						advertisementAsset.children &&
						advertisementAsset.children?.length > 0
							? advertisementAsset.children[0].url
							: '';
					updatedCampaignAdvertisement.thumbnailUrl =
						advertisementAsset.children &&
						advertisementAsset.children?.length > 0
							? advertisementAsset.children[0].url
							: '';
				}

				const updatedCampaignAdvertisements = state.campaign.campaignAdvertisements.map(
					(campaignAd: CampaignAdvertisement) => {
						if (campaignAd.index === updatedCampaignAdvertisement.index) {
							return updatedCampaignAdvertisement;
						} else {
							return campaignAd;
						}
					},
				);
				const updatedCampaign = { ...state.campaign };
				updatedCampaign.campaignAdvertisements = [
					...updatedCampaignAdvertisements,
				];
				let price = 0;
				state.campaign.campaignAdvertisements.forEach(
					(campaignAdvertisement: CampaignAdvertisement) => {
						price = price + campaignAdvertisement.calculatedBudget;
					},
				);
				price = price + updatedCampaignAdvertisement.calculatedBudget;

				updatedCampaign.campaignAdvertisements = [
					...updatedCampaign.campaignAdvertisements,
					updatedCampaignAdvertisement,
				];
				updatedCampaign.price = price;
				return {
					...state,
					campaign: { ...updatedCampaign },
				};
			}
		}

		case GET_MAIN_LOCATIONS_SEARCH_BY_AREA: {
			const results: Array<MainLocationAllocation> = action.payload;
			const updatedResult: Array<MainLocationAllocation> = results.map(
				(location: MainLocationAllocation) => {
					const updatedLocationObject: MainLocationAllocation = {
						...location,
						selectedDevices: 1,
						noOfTimes: 1,
						added: false,
					};
					return updatedLocationObject;
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedResult,
				},
			};
		}

		case GET_LOCATION_GROUP_SEARCH_BY_CITY: {
			const results: Array<LocationGroupCampaignSearch> = action.payload;
			const updatedResult: Array<LocationGroupCampaignSearch> = results.map(
				(locationGroup: LocationGroupCampaignSearch) => {
					const updatedLocationGroupObject: LocationGroupCampaignSearch = {
						...locationGroup,
						selectedDevices: 1,
						noOfTimes: 1,
						added: false,
					};
					return updatedLocationGroupObject;
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedResult,
				},
			};
		}

		case UPDATE_AUTO_RESULT_UI_STATE: {
			if (action.payload) {
				return {
					...state,
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						showConfirm: true,
						toolbarMode: 'row',
						toolbarColSize: 12,
						mainContainerAlign: 'center',
						isNewlyAllocatedSlots: true,
					},
				};
			} else {
				return {
					...state,
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						showConfirm: false,
						isNewlyAllocatedSlots: false,
					},
				};
			}
		}

		case UPDATE_CAMPAIGN_AD_UI_STATE: {
			return {
				...state,
				campaignAdvertisementState: {
					...state.campaignAdvertisementState,
					...action.payload,
				},
			};
		}

		case GET_LOCATION_GROUP_MANUAL_RESULT: {
			if (action.payload.locations.length) {
				return {
					...state,
					currentSlotResults: action.payload,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						selectedLocationGroups: [...action.payload.locations],
						calculatedBudget: action.payload.budget,
						uuid: action.payload.uuid,
					},
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						tabValue: 1,
						showConfirm: true,
						toolbarColSize: 12,
						mainContainerAlign: 'center',
						toolbarMode: 'row',
						isNewlyAllocatedSlots: true,
					},
				};
			} else {
				return {
					...state,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						selectedLocationGroups: [],
						calculatedBudget: 0,
						uuid: action.payload.uuid,
					},
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						tabValue: 0,
						showConfirm: false,
						isNewlyAllocatedSlots: false,
					},
					currentSlotResults: emptySlotResults,
				};
			}
		}

		case GET_MAIN_LOCATION_MANUAL_RESULT: {
			if (action.payload.locations.length) {
				return {
					...state,
					currentSlotResults: action.payload,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						selectedLocations: [...action.payload.locations],
						calculatedBudget: action.payload.budget,
						uuid: action.payload.uuid,
					},
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						tabValue: 1,
						showConfirm: true,
						toolbarColSize: 12,
						mainContainerAlign: 'center',
						toolbarMode: 'row',
						isNewlyAllocatedSlots: true,
					},
				};
			} else {
				return {
					...state,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						selectedLocations: [],
						calculatedBudget: 0,
						uuid: action.payload.uuid,
					},
					campaignAdvertisementState: {
						...state.campaignAdvertisementState,
						tabValue: 0,
						showConfirm: false,
						isNewlyAllocatedSlots: false,
					},
					currentSlotResults: emptySlotResults,
				};
			}
		}

		case RESET_CAMPAIGN_STATE: {
			return {
				...state,
				campaign: {
					...emptyCampaignObject,
				},
				campaignAdvertisementForm: {
					...emptyCampaignAdvertisement,
				},
				campaignAdvertisementState: {
					...initialCampaignAdvertisementUIState,
				},
				mode: 'CREATE',
				selectedId: 0,
			};
		}
		case GET_CAMPAIGN_BY_ID: {
			return {
				...state,
				campaign: {
					...action.payload,
				},
			};
		}

		case GET_MAIN_LOCATION_AUTO_RESULT: {
			if (action.payload.locations.length) {
				return {
					...state,
					currentSlotResults: action.payload,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						calculatedBudget: action.payload.budget,
						uuid: action.payload.uuid,
						selectedLocations: [...action.payload.locations],
					},
				};
			} else {
				return {
					...state,
					campaignAdvertisementForm: {
						...state.campaignAdvertisementForm,
						calculatedBudget: 0,
						uuid: action.payload.uuid,
						selectedLocations: [],
					},
				};
			}
		}

		case UPDATE_CAMPAIGN_FORM: {
			return {
				...state,
				campaign: { ...state.campaign, ...action.payload },
			};
		}

		case UPDATE_CAMPAIGN_ADVERTISEMENT_FORM: {
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					...action.payload,
				},
			};
		}

		case RESET_CAMPAIGN_ADVERTISEMENT_FORM: {
			return {
				...state,
				campaignAdvertisementForm: {
					...emptyCampaignAdvertisement,
				},
				campaignAdvertisementState: {
					...initialCampaignAdvertisementUIState,
				},
			};
		}

		case RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE: {
			return {
				...state,
				campaignAdvertisementState: {
					...initialCampaignAdvertisementUIState,
				},
			};
		}

		case CAMPAIGN_MANUAL_ADD_LOCATION: {
			const location: MainLocationAllocation = action.payload;
			location.added = true;
			const searchedLocations = state.campaignAdvertisementForm.searchLocations;
			const updatedSearchedLocations: Array<MainLocationAllocation> = searchedLocations.map(
				(locationInfo: MainLocationAllocation) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedSearchedLocations,
				},
			};
		}

		case CAMPAIGN_MANUAL_ADD_LOCATION_GROUP: {
			const location: LocationGroupCampaignSearch = action.payload;
			location.added = true;
			const searchedLocationsGroups =
				state.campaignAdvertisementForm.searchLocationGroups;
			const updatedSearchedLocationsGroups: Array<LocationGroupCampaignSearch> = searchedLocationsGroups.map(
				(locationInfo: LocationGroupCampaignSearch) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedSearchedLocationsGroups,
				},
			};
		}

		case CAMPAIGN_MANUAL_DELETE_LOCATION: {
			const location: MainLocationAllocation = action.payload;
			location.added = false;
			const searchedLocations = state.campaignAdvertisementForm.searchLocations;
			const updatedSearchedLocations: Array<MainLocationAllocation> = searchedLocations.map(
				(locationInfo: MainLocationAllocation) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedSearchedLocations,
				},
			};
		}

		case CAMPAIGN_MANUAL_DELETE_LOCATION_GROUP: {
			const location: LocationGroupCampaignSearch = action.payload;
			location.added = false;
			const searchedLocationGroups =
				state.campaignAdvertisementForm.searchLocationGroups;
			const updatedSearchedLocationGroups: Array<LocationGroupCampaignSearch> = searchedLocationGroups.map(
				(locationInfo: LocationGroupCampaignSearch) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedSearchedLocationGroups,
				},
			};
		}

		case UPDATE_LOCATION_MANUAL_NO_TIMES: {
			const location: MainLocationAllocation = action.payload.location;
			location.noOfTimes = action.payload.noOfTimes;
			const searchedLocations = state.campaignAdvertisementForm.searchLocations;
			const updatedSearchedLocations: Array<MainLocationAllocation> = searchedLocations.map(
				(locationInfo: MainLocationAllocation) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedSearchedLocations,
				},
			};
		}

		case UPDATE_LOCATION_GROUP_MANUAL_NO_TIMES: {
			const locationGroup: LocationGroupCampaignSearch =
				action.payload.locationGroup;
			locationGroup.noOfTimes = action.payload.noOfTimes;
			const searchedLocationGroups =
				state.campaignAdvertisementForm.searchLocationGroups;
			const updatedSearchedLocationGroups: Array<LocationGroupCampaignSearch> = searchedLocationGroups.map(
				(locationInfo: LocationGroupCampaignSearch) => {
					if (locationInfo.id === locationGroup.id) {
						return locationGroup;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedSearchedLocationGroups,
				},
			};
		}

		case UPDATE_LOCATION_SELECT_ALL_DEVICES: {
			const location: MainLocationAllocation = action.payload;
			if (!location.selectAllDevices) {
				location.selectedDevices = action.payload.availableDevices;
				location.selectAllDevices = true;
			} else {
				location.selectAllDevices = false;
			}
			const searchedLocations = state.campaignAdvertisementForm.searchLocations;
			const updatedSearchedLocations: Array<MainLocationAllocation> = searchedLocations.map(
				(locationInfo: MainLocationAllocation) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);

			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedSearchedLocations,
				},
			};
		}

		case UPDATE_LOCATION_GROUP_SELECT_ALL_DEVICES: {
			const locationGroup: LocationGroupCampaignSearch = action.payload;
			if (!locationGroup.selectAllDevices) {
				locationGroup.selectedDevices = action.payload.availableDevices;
				locationGroup.selectAllDevices = true;
			} else {
				locationGroup.selectAllDevices = false;
			}

			const searchedLocationGroups =
				state.campaignAdvertisementForm.searchLocationGroups;
			const updatedSearchedLocations: Array<LocationGroupCampaignSearch> = searchedLocationGroups.map(
				(locationInfo: LocationGroupCampaignSearch) => {
					if (locationInfo.id === locationGroup.id) {
						return locationGroup;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedSearchedLocations,
				},
			};
		}

		case UPDATE_LOCATION_MANUAL_SELECTED_DEVICES: {
			const location: MainLocationAllocation = action.payload.location;
			location.selectedDevices = action.payload.selectedDevices;
			const searchedLocations = state.campaignAdvertisementForm.searchLocations;
			const updatedSearchedLocations: Array<MainLocationAllocation> = searchedLocations.map(
				(locationInfo: MainLocationAllocation) => {
					if (locationInfo.id === location.id) {
						return location;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocations: updatedSearchedLocations,
				},
			};
		}

		case UPDATE_LOCATION_GROUP_MANUAL_SELECTED_DEVICES: {
			const locationGroup: LocationGroupCampaignSearch =
				action.payload.locationGroup;
			locationGroup.selectedDevices = action.payload.selectedDevices;
			const searchedLocationGroups =
				state.campaignAdvertisementForm.searchLocationGroups;
			const updatedSearchedLocations: Array<LocationGroupCampaignSearch> = searchedLocationGroups.map(
				(locationInfo: LocationGroupCampaignSearch) => {
					if (locationInfo.id === locationGroup.id) {
						return locationGroup;
					} else {
						return locationInfo;
					}
				},
			);
			return {
				...state,
				campaignAdvertisementForm: {
					...state.campaignAdvertisementForm,
					searchLocationGroups: updatedSearchedLocations,
				},
			};
		}

		case CAMPAIGN_MANUAL_LOCATION_BOOK_SLOT: {
			return {
				...state,
			};
		}

		default: {
			return {
				...state,
			};
		}
	}
};
